import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const checkIsVoip = async (phoneNumber: string) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
    },
    mutation: graphql(`
      mutation IsVoip($phoneNumber: String!) {
        isVoip(phoneNumber: $phoneNumber)
      }
    `),
  });

  return response.data?.isVoip ?? false;
};
